import { Button, Card, Row, Col } from "react-bootstrap";

// Component used to explain to users how to get help regarding the PHIL app
export default function Support() {
  //TODO: This should not be hardcoded, maybe shouldd be present at a secret vault and environment dependent.
  const EMAIL =
    "mailto:PHIL - Support <54888d1d.bayergroup.onmicrosoft.com@emea.teams.ms>";
  const CHANNEL =
    "https://statics.teams.cdn.office.net/evergreen-assets/safelinks/1/atp-safelinks.html?url=https%3A%2F%2Fbayergroup.sharepoint.com%2F%3Al%3A%2Fs%2FPHIL266%2FFEQJRRuR6m5Nuh7m5ELci_IB6rIR3VHJMFoJ0z-MI-fCyA%3Fnav%3DZDU4YTQ2ZTUtNjhhMi00ODYzLWEzNzUtOGY3ZWFjMDZjYjc0&locale=de-de&dest=https%3A%2F%2Fteams.microsoft.com%2Fapi%2Fmt%2Fpart%2Femea-03%2Fbeta%2Fatpsafelinks%2Fgeturlreputationsitev2%2F&pc=fKpk9Me37a3fgJie4Ahu%252bwtJtmiclxMnz%252flfYOvmbyCQ%252b51%252b79uiT1Npc%252bjaeELMEhwrjubWvAdOzjAAk1DepYOze8EiLS%252fzc7M6sWKsN%252f4gR%252bDvPdlpl6v534%252fdHqsRaOEq%252f4QZYAaJnbuGUB%252fm5zH1%252bhifDTiqVYBL2I7WzSAtEOECrQUfjRm3Gb6VCaghYKmUgePT0e%252b72mxYR5p96yukwGd%252bLy2XWpu9GBmRisxp4CLC1O2LaY0aUAnnxdPcIwC2qE5p%252bomOdYuzMJ05WpaUzN6A0uCXIRCts6%252bYbljf04oZWLiG32AC9G6%252bAVhpVfDwrc%252fqJ23KIBr51dbOAThjmW%252bkOQDsEvOTwIzwfj6z0OC3t6t3EiUSi%252fgKSfXfjK2NemeKK5XU7IVJrLQx0iFDeiAvqOSCG013jyxnlSJRPa4rs9yolJWZ%252ff3MWBIJQ5nmZvOdr6Vb5NU%252f%252bgiHhrGaFJPckNmmh3Tc3xG8gxzPrw%252f0G7tHbr28zGqB05OhQXZW4dGVTw6iT2jsMtxZBRpcxuR3oizS2fQAq6IvJH4mxCbp8J6jQmSq%252fYOZN%252fHkpWPV4djaI0ECp3mLiNvNvv2Ae4hmxaRCUDgH0Y7c6gtW6HgbDKQAGIws1xyeIWP1TnCjM6%252blVgy79AMYEHG3jDwMRl0wN1OGRMes8ktpb%252bCAXT6YaeoVuRXYaKbCBU6RnJZ2tr%252fznMb7DKUlKlvA6BqCPdMBo%252bkyzt58YQwdMKcYPyZDxSNPy1xAI6acDEPWhrvdonfB%252bjCeOpcz0rHWfyi%252bDhfxkeMqSxnnb8iPmUV6q2xeJCkg0yd24Lco0inTgSNRU%252b01vwKF%252bmBRHKjRWFln6amb5P4DTssw42kQBZ3xBTP8%252bbkBv9ufKDMmsKGDu1mwmALcw%252fWynj5mnT7eIJ%252fFekT7tG%252b76Sj2BzhAoHQx1unlMAlKBlkXUNlE2VGoyb15aLqxbWDQK9Fdj7095IYel1eDsolX0E%252b5wxEjp9yc4TX680oiDjm9rmXuqEjKMvRsczw7PVSY%252bwNVFTR1vsyDOJzHWfDGtJ%252fYD%252fDOJ91tL5JCdrmz9JAihexl57p8d6coOFMvJEu2IvfZpf7vE6KZVxaiuKBDgnNBViEv9vnZR9RkcVmrmuoD01UT9N%252bRfrqLZ9Ds6vwo%252ffmhGcseow1Kv2%252fNh3CE2YfyL0yNQZ9KFVfAEbJCsU1AT6yuy%252bEmrzyqLOtBahsLAiNdNTp1YAXzJncZcmxAZaChVPyYU6xfr18qJMehdnf4DDMyStoU36GawCke0eiy%252bTnlsWDJcErlgdAzwmhsh3VwdLS0GUGdUv%252fi5aiIQQss%252bYujhPbIbu1E8ceuXwV0QSy%252fpdTDpF6Tm24G%252buVpg59wrU3eSr2%252ftfCzqVNAHSVOFGOoVmSZVeo%252bXbd6mHxQZCQBxsvMBcSkeoyn6lPWpy7gbXMLRPo%253d%3B%20expires%3DSun%2C%2013%20Jul%202025%2007%3A56%3A32%20GMT%3B%20path%3D%2F%3B%20SameSite%3DNone%3B%20secure%3B%20httponly&wau=https%3A%2F%2FEUR03.safelinks.protection.outlook.com%2FGetUrlReputation&si=undefined%3B%3B19%3Ad5a247acd11c415184b8723a5ed13f96%40thread.tacv2&sd=%7BconvId%3A%2019%3Ad5a247acd11c415184b8723a5ed13f96%40thread.tacv2%2C%20messageId%3A%20%7D&ce=prod&cv=49%2F25061216424&ssid=bebade8b-e432-49b6-9724-f2e31fae3cfd&ring=general&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA2MTIxNjQyNCJ9&bg=%23f0f0f0&fg=%23242424&fg2=%239092c1";
  const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const onClickUrl =
    (url: string): (() => void) =>
    () =>
      openInNewTab(url);

  return (
    <div className="app_content">
      <div>
        <h3>Welcome to the PHIL contact page!</h3>
        <Row className="mb-3">
          <Col xs={5}>
            <Card>
              <Card.Body>
                <Card.Title>Teams Channel</Card.Title>
                <Card.Text className="text-color-light fs-7">
                  Please contact the PHIL support team through our Support
                  Requets Form. The recommended communication channel for Bayer
                  users.
                </Card.Text>
                <Button onClick={onClickUrl(CHANNEL)}>Bayer User</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs={5}>
            <Card>
              <Card.Body>
                <Card.Title>E-mail</Card.Title>
                <Card.Text className="text-color-light fs-7">
                  Please contact the PHIL support team through our dedicated
                  PHIL support e-mail. The recommended communication channel for
                  external users.
                </Card.Text>
                <Button onClick={onClickUrl(EMAIL)}>External User</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
